import { Injectable, inject } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

/**
 * Automatic service worker update handler.
 * 
 * Checks for updates on app startup and automatically activates + reloads when new version is available.
 * Updates are only checked on page load/refresh, never during active sessions.
 * 
 * Requires server to NOT cache: ngsw.json, ngsw-worker.js, and index.html
 */
@Injectable({ providedIn: 'root' })
export class ServiceWorkerUpdateService {
  private readonly swUpdate = inject(SwUpdate);

  constructor() {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    this.swUpdate.versionUpdates.subscribe((evt) => {
      if (evt.type === 'VERSION_READY') {
        this.swUpdate.activateUpdate().then(() => {
          window.location.reload();
        });
      }
    });

    this.swUpdate.unrecoverable.subscribe(() => {
      document.location.reload();
    });

    this.swUpdate.checkForUpdate();
  }
}
